import { Translate } from '@dreryk/react-common';
import { TextView } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../translations';

const DocumentTypeTextView = (): JSX.Element => {
   return (
      <TextView label={entitlementStatementsTranslationKeys.createModal.documentType} testId={'documentType'}>
         <Translate>{entitlementStatementsTranslationKeys.createModal.documentTypeDescription}</Translate>
      </TextView>
   );
};

export { DocumentTypeTextView };
